import { connect } from "@formily/react";

export const Grid = connect((props) => {
  return (
    <div
      style={{
        display: "grid",
        gap: 8,
        ...props.style, // allows override
      }}
      className={props.className}
    >
      {props.children}
    </div>
  );
});
